import { usersRepo } from '@/constants/providers';
import { HttpError } from '@/core/http';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { HttpStatusCode } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { CreateUserJson } from '../types';

export const useCreateUser = (
  onSuccess?: (data: ApiResponse<{ userId: number }>) => void,
) => {
  const { t } = useTranslation();
  return useMutation<ApiResponse<{ userId: number }>, unknown, CreateUserJson>(
    (user) => usersRepo.createUser(user),
    {
      onSuccess: (data) => {
        toast.success(t('success_creating_user'));
        onSuccess?.(data);
      },
      onError: (error) => {
        if ((error as HttpError<unknown>)?.code === HttpStatusCode.BadRequest) {
          toast.error(t('user_already_exists'));
        } else {
          toast.error(t('error_creating_user'));
        }
      },
    },
  );
};
